import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const config = createAsyncThunk(
  "config/configUsers",
  async (payload, thunkAPI) => {
    try {
      let url = "config";
      const { vpnToken, ...restPayload } = payload || {};

      // If vpnToken is present, add it to the query params
      if (vpnToken) {
        url += `?vpnToken=${encodeURIComponent(vpnToken)}`;
        console.log("url", url);
      }

      const response = await api.post(url, restPayload);
      return response.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const configSlice = createSlice({
  name: "config",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(config.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(config.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Store API response
      })
      .addCase(config.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch config";
      });
  },
});

export default configSlice.reducer;
